import React, { Component } from "react";
import { Accessor, IconX, ZTime } from "IZOX/STATIC";
import PropsType from "prop-types";
import _ from "lodash";
import { HStack, Spacer, VStack, XButton, XText } from "IZOX/_X";

/**
 * @augments {Component<Props, State>}
 */
class YearCore extends Component {

  static propTypes = {
    disYear: PropsType.number,
    disMonth: PropsType.number,
    _isValidYear: PropsType.func,
    _onSelectorChange: PropsType.func,
    styles: PropsType.object
  };

  static defaultProps = {
    disYear: ZTime.Now().year(),
    disMonth: ZTime.Now().month(),
    _isValidYear: null,
    _onSelectorChange: null,
    styles: {}
  };

  constructor(props){
    super();
    let {disYear} = props;
    this.state = {
      yearPage: disYear - disYear % 10
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(YearCore.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  };

  onBtnPress = (year) => {
    let {disMonth, _onSelectorChange} = this.props;
    _onSelectorChange?.(year, disMonth);
  };

  onLeftPress = () => {
    let {_isValidYear} = this.props;
    let {yearPage} = this.state;
    if(!_isValidYear(yearPage - 1)) return;
    this.setState({
      yearPage: yearPage - 10
    });
  };

  onRightPress = () => {
    let {_isValidYear} = this.props;
    let {yearPage} = this.state;
    if(!_isValidYear(yearPage + 10)) return;
    this.setState({
      yearPage: yearPage + 10
    });
  };

  renderBtn(icon, func, disabled = false){
    let {size, styles} = this.props;
    return (
      <XButton onClick={func} 
        style={styles.shiftYearBtn(size)} 
        disabled={disabled}>
        {icon}
      </XButton>
    );
  }

  renderYearBtn(year, key){
    let {disYear, _isValidYear, size, styles} = this.props;
    let style = styles.coreYearBtnText(size);
    let isValid = _isValidYear?.(year) ?? false;

    if(disYear === year){
      style = {
        ...style, 
        ...styles.coreYearBtnTextInSelect(size)
      };
    }
    if(!isValid){
      style = {
        ...style,
        ...styles.coreYearBtnTextDisabled(size)
      };
    }

    return (
      <XButton key={key}
        disabled={!isValid}
        onClick={(e) => {
          e.stopPropagation();
          this.onBtnPress(year);
        }} 
        style={styles.coreYearBtn(size)}>
        <XText style={style}>
          {String(year)}
        </XText>
      </XButton>
    );
  }

  renderYearBtnList(start, end){
    return (
      <VStack width={"40%"}>
        {_.map(_.range(start, end), (o, i) => {
          return this.renderYearBtn(o, i);
        })}
      </VStack>
    );
  }

  render(){
    let {_isValidYear, styles} = this.props;
    let {yearPage} = this.state;
    return (
      <HStack>
        {this.renderBtn(
          IconX.Get("awesome", "chevron-left", 16,
           !_isValidYear(yearPage - 1) ? 
            styles.shiftIconDisabled.color 
            : styles.shiftIcon.color),
          this.onLeftPress, 
          !_isValidYear(yearPage - 1))
          }
        <Spacer/>
        {this.renderYearBtnList(yearPage, yearPage + 5)}
        {this.renderYearBtnList(yearPage + 5, yearPage + 10)}
        <Spacer/>
        {this.renderBtn(
          IconX.Get("awesome", "chevron-right", 16,
          !_isValidYear(yearPage + 10) ? 
           styles.shiftIconDisabled.color 
           : styles.shiftIcon.color),
          this.onRightPress, 
          !_isValidYear(yearPage + 10))}
      </HStack>
    );
  }

}

export default YearCore;
